import { render, staticRenderFns } from "./VueText.vue?vue&type=template&id=1b74aef4&"
import script from "./VueText.vue?vue&type=script&lang=js&"
export * from "./VueText.vue?vue&type=script&lang=js&"
import style0 from "./VueText.vue?vue&type=style&index=0&id=1b74aef4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports